<div *ngIf="displayComponent" class="d-flex">
  <select class="q-main-select" [ngModel]="selectedModel" (ngModelChange)="OnModelChange($event)">
    <ng-container *ngIf="model.Header.SavedModels">
      <option *ngFor="let model of model.Header.SavedModels" [value]="model.value">{{model.key}}</option>
    </ng-container>
  </select>
  <button class="q-btn q-white ml-2"
          [ngbPopover]="f1"
          [placement]="['auto', 'auto']"
          autoClose="outside"
          container="body"
          #p1="ngbPopover">
    <i class="fas fa-plus q-c-main"></i>
  </button>


  <ng-template #f1>
    <div class="w-100">
      <form #form>
        <div class="container-fluid">
          <div class="row">
            <input name="input" type="text" class="q-input-border mb-0 mr-2"
                   [ngClass]="{'q-c-danger': emptyModelName}"
                   [(ngModel)]="newModelName"
                   placeholder="nouveau modèle"
                   (focus)="emptyModelName = false;"/>
            <button class="col-auto q-btn q-main" (click)="SaveModel()">
              <i class="fas fa-save"></i>
            </button>
          </div>
        </div>
      </form>
    </div>

  </ng-template>
</div>
